import React, { useState, useEffect } from "react";
import style from "./block.module.scss";
import Button from "../shared/button-icon";
import {ReactComponent as IconButtonYes} from "../assets/check.svg";
import {ReactComponent as IconButtonNo} from "../assets/cross.svg";
import Logo from "./logo.svg";
import { useTranslation } from 'react-i18next';

function Block(){
    const { t } = useTranslation();
    const [alert, setAlert] = useState(false)
    const [ageConfirm, setAgeConfirm] = useState(() => {
        try {
            const item = window.sessionStorage.getItem('getAge');
            return item ? JSON.parse(item) : false;
        } catch (error) {
            return false;
        }
    });

    useEffect(() => {
        if(ageConfirm){
            window.sessionStorage.setItem('getAge', true);
        }
    }, [ageConfirm]);

    useEffect(() => {
        if(!ageConfirm){
            document.body.style.overflowY = "hidden";
            return () => {
                document.body.style.overflowY = null;
            }
        }
    }, [ageConfirm]);
    return <div>
            {!ageConfirm ?
                <div className={style.block}>
                    <div/>
                    <div className={style.content}>
                        <div className={style.textBloc}>
                            <img src={Logo} alt="Logo"/>
                            <h2 className={style.title}>{t("Vous devez avoir l’âge légal* pour la consommation d’alcool pour pouvoir accéder à ce site.")}</h2>
                            <div className={style.button}>
                                <Button classIcon={style.icon} Icon={IconButtonYes} className={style.buttonYes} onClick={() => setAgeConfirm(true)}>{t("JE SUIS MAJEUR")}</Button>
                                <Button classIcon={style.icon} Icon={IconButtonNo} className={style.buttonNo} onClick={() => setAlert(true)}>{t("JE NE SUIS PAS MAJEUR")}</Button>
                            </div>
                            <p className={style.condition}>{t("*selon l'âge légal dans mon pays.")}</p>
                            {alert ? 
                                <p className={style.alert}>{t("Vous devez être majeur pour accéder au site.")}</p>
                                : ''
                            }
                        </div>
                    </div>
                    <p className={style.legend}>{t("L’abus d’alcool est dangereux pour la santé. À consommer avec modération.")}</p>
                </div> : ''
                }
            </div>
}

export default Block;